<div class="flex justify-between">
  <div>
    @if (control?.hasError("required") && control.touched) {
      <app-validator
        [question]="question"
        [validator]="ValidatorType.RequiredText"
      />
    }
    @if (control?.hasError("pattern") && control.touched) {
      <app-validator
        [question]="question"
        [validator]="ValidatorType.Pattern"
        [control]="control"
      />
    }
    @if (control?.hasError("maxLength") && control.touched) {
      <app-validator
        [question]="question"
        [validator]="ValidatorType.MaxLength"
        [control]="control"
      />
    }
  </div>
  <p
    class="text-xs pl-2 pr-2 pt-1"
    [ngClass]="{
      'validation-dynamic-theme':
        (question.presentation === 'SINGLE_LINE' &&
          control.value?.length > 255) ||
        (question.presentation === 'MULTI_LINE' &&
          (control.value | numberOfBytes) > 4000),
    }"
  >
    @if (question.presentation === "SINGLE_LINE") {
      <span aria-hidden="true">
        {{ control.value?.length ?? 0 }}/255</span
      >
    } @else if (question.presentation === "MULTI_LINE") {
      <span aria-hidden="true">{{ control.value | numberOfBytes }}/4000</span>
    }
  </p>
</div>
